export default __webpack_public_path__ + "maps-examples-custom-style-1200-b4aba9dd6995ddfce10c99ec48624789.webp";